/**
 * @description
 * Utility function that validates if an object is empty
 * @param {Object} obj the object to validate against
 */
const isEmptyObject = (obj: any): boolean => obj && Object.keys(obj).length === 0;

export default isEmptyObject;
